/* eslint-disable no-unused-expressions */
import React from 'react';
import {connect} from 'react-redux';
import './CreateList.scss';
import {CheckBoxListProvider} from '../CheckBoxList/BlockCheckboxList';
import {store} from '../../Redux/Store/Store';
import {Collapse} from 'react-collapse';
import * as actionsBlocks from '../../Redux/Actions/Blocks';
import * as PropertyBucket from '../../Properties/Properties';
import {QuestionListDto} from '../Dtos/QuestionListDto';
import {QuestionInBlockDto} from '../Dtos/QuestionInBlockDto';
import {BlockInListDto} from '../Dtos/BlockInListDto';
import * as httpService from '../HttpService/HttpService';
import * as validator from '../Validators/ControlValidator.js';
import {Waiter} from '.././WaitingSign/Waiting';
import Checkbox from '@mui/material/Checkbox';
import PopUp from '.././PopUp/PopUp';
import Input from '../Input/Input';
import {Prompt} from 'react-router-dom';
import {getUserProgramFromPwd, getUserRole, isURLContainString} from '../../Helpers/utils';
import orderBy from "lodash/orderBy";
import filter from "lodash/filter";


class CreateList extends React.Component {
    listId;


    constructor(props) {
        super(props);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.addQuestion = this.addQuestion.bind(this);
        this.state = {
            violations: null,
            showPopup: false,
            popUp: {title: null, notification: null},
            showBlocks: false,
            showAddQuestion: false,
            isCollapsedMap: new Map(),
            isCheckedMap: new Map(),
            isWaiting: false,
            activeBlock: {id: 0, name: ''},
            listData: {name: ''},
            listDataSource: {name: ''},
            pickedBlocks: [],
            pickedBlocksSource: JSON.parse(JSON.stringify(this.props.pickedBlocks.pickedBlocks)),
            listNameClasses: [],
            save: 'new',
            title: 'Utwórz listę',
            disabled: '',
            isChangeRoutePossible: true,
            changeRouteAfterSave: false,
            isPreventPromptEnabled: true,
            showMoveQuestionAlert: false,
            moveQuestionAlertContent: '',
            isAnyBlocksSelected: false,
            questionSearchText: '',
            // Cache of questions fetched for each block, keyed by blockId
            // Used to avoid fetching the same questions multiple times and maintain state between rerenders
            blockQuestionsMap: new Map(),
            // Tracks whether questions are currently being loaded for each block, keyed by blockId
            // Used to show loading indicators and prevent duplicate fetch requests
            blockQuestionsLoading: new Map()
        };
        this.handleClosePopUp = this.handleClosePopUp.bind(this);
    }

    componentDidMount() {
        document.title = `e-Kontrole | ${this.state.title}`;
        const {blocksData} = this.props;
        blocksData();
        this.setState({pickedBlock: this.props.pickedBlocks.pickedBlocks});
        if (this.props.match.params.listId || this.props.match.params.parentListId) {
            this.isWaitingOnOff(true);
            this.listId = this.props.match.params.listId ? this.props.match.params.listId : this.props.match.params.parentListId;
            let save = this.props.match.params.listId ? 'edit' : 'copy';
            let title = this.props.match.params.listId ? 'Edytuj listę' : 'Tworzenie kopii listy';
            let url = PropertyBucket.getList(this.listId);
            this.controlResponse = httpService.getService(url, 'GET');
            this.controlResponse
                .then(data => {
                    let pickedBlocks = [];
                    this.props.match.params.parentListId ? data.name = data.name + ' (kopia)' : null;
                    data.blocksInList.forEach((blockInList) => {
                        let block = blockInList;
                        block.id = blockInList.block?.id;
                        block.additionalQuestions = [];
                        block.questionsInBlock = blockInList.questionsInBlock;
                        if (this.props.match.params.parentListId) {
                            block.questionsInBlock.forEach((questionInBlock, index) => {
                                questionInBlock.questionInBlockId = null;
                            })
                        }
                        pickedBlocks.push(block);
                    });
                    this.props.pickedData(pickedBlocks);

                    this.setState({
                        listData: data,
                        listDataSource: data,
                        pickedBlocks: pickedBlocks,
                        pickedBlocksSource: JSON.parse(JSON.stringify(pickedBlocks)), // deep copy
                        save: save,
                        title: title,
                        isWaiting: false
                    })
                })
                .catch(error => {
                    this.setState({
                        showPopup: true,
                        popUp: {title: 'Błąd', notification: error.message, type: 'error'},
                        isWaiting: false
                    })
                });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const isDataChanged = this.isDataChanged();
        if (isDataChanged && this.state.isChangeRoutePossible && !this.state.changeRouteAfterSave) {
            this.setState({isChangeRoutePossible: false})
        } else if (!isDataChanged && !this.state.isChangeRoutePossible && this.state.changeRouteAfterSave) {
            this.setState({isChangeRoutePossible: true})
            this.setState({isAnyBlocksSelected: true})
        }

        if (!this.state.disabled && this.state.violations) this.setState({violations: null});
        
        const currentPickedBlocks = this.props.pickedBlocks.pickedBlocks;
        const prevPickedBlocks = prevProps.pickedBlocks.pickedBlocks;
        
        if (currentPickedBlocks.length !== prevPickedBlocks.length) {
            this.syncNewlyAddedBlocksWithCachedQuestions(currentPickedBlocks, prevPickedBlocks);
        }
    }

    componentWillUnmount() {
        this.props.pickedData([]);
    }

    isDataChanged() {
        if (this.state.listData.name !== this.state.listDataSource.name) {
            return true;
        }

        const pData = JSON.stringify(this.state.pickedBlock);
        const source = JSON.stringify(this.state.pickedBlocksSource);

        if (pData !== source) {
            return true;
        }

        return false;

    }

    handleClosePopUp() {
        this.setState({showPopup: false});
    }

    preventChangeRoute = (newLocation) => {
        if (!this.state.isChangeRoutePossible) {
            this.setState({
                showPopup: true,
                popUp: {
                    title: 'Ostrzeżenie',
                    notification: PropertyBucket.getCancelMessage(),
                    type: 'cancel',
                    newLocationLink: newLocation,
                    onCLick: () => {
                        this.setState({isChangeRoutePossible: true}, () => {
                            this.props.history.push(newLocation)
                        })
                    }
                }
            });
            return false;
        }

        return true;
    };

    isWaitingOnOff = (OnOff) => {
        this.setState({
            isWaiting: OnOff
        })
    };

    convertQuestionIntoQuestionInBlock = (question) => {
        let questionInBlockDto = new QuestionInBlockDto();
        questionInBlockDto.questionContent = question.question == undefined ? question.questionContent : question.question;
        questionInBlockDto.active = question.active;
        questionInBlockDto.orderNumber = question.orderNumber;
        questionInBlockDto.abbrev = question.abbrev;
        questionInBlockDto.additional = question.additional;
        questionInBlockDto.block = question.block;

        return questionInBlockDto;
    };
    
    handleChangeName = (e) => {
        const listData = e.target.value.length > 500 ? e.target.value.substring(0, 500) : e.target.value;

        this.setState({
            listData: {name: listData},
            disabled: ''
        });
    };

    addBlock = () => {
        this.setState({
            showBlocks: true,
        });
    };

    addQuestion = (blockId, question, event) => {
        let checked = event.target.checked;
        let pickedBlocks = store.getState().pickedBlocks.pickedBlocks;
        let abbrev = question.abbrev;
        let orderNumber;
        let _this = this;
        pickedBlocks.forEach(function (block, index) {
            if (block.id === blockId) {
                if (checked) {
                    let questionInBlockDto = _this.convertQuestionIntoQuestionInBlock(question);
                    !block.questionsInBlock ? block.questionsInBlock = [] : null;
                    if (block.questionsInBlock.length > 0) {
                        orderNumber = block.questionsInBlock[block.questionsInBlock.length - 1].orderNumber + 1;
                    } else {
                        orderNumber = 1;
                    }
                    questionInBlockDto.orderNumber = orderNumber;
                    block.questionsInBlock.push(questionInBlockDto);
                } else {
                    let arrayCopy = block.questionsInBlock;
                    block.questionsInBlock.forEach(function (questionInBlock, index) {
                        if (questionInBlock.abbrev === abbrev) {
                            arrayCopy.splice(index, 1);
                        }
                    });
                }
            }
        });
        
        if (this.state.blockQuestionsMap.has(blockId)) {
            const currentBlockQuestions = this.state.blockQuestionsMap.get(blockId);

            const updatedBlockQuestionsMap = new Map(this.state.blockQuestionsMap);
            updatedBlockQuestionsMap.set(blockId, currentBlockQuestions);
            
            this.setState({
                blockQuestionsMap: updatedBlockQuestionsMap,
                pickedBlocks: [...pickedBlocks]
            });
        }

        this.props.pickedData(pickedBlocks);

        this.setState({
            showBlocks: false
        });
    };

    addAllQuestions = (blockId, questions, event) => {
        let checked = event.target.checked;
        let pickedBlocks = store.getState().pickedBlocks.pickedBlocks;
        let copiedIsCheckedMap = this.state.isCheckedMap;
        let orderNumber;
        let _this = this;
        pickedBlocks.forEach(function (block, index) {
            if (block.id === blockId) {
                if (checked) {
                    copiedIsCheckedMap.set(blockId, true);
                    orderBy(questions, ['orderNumber', 'asc']).forEach(function (question, index) {
                        if (!block.questionsInBlock.some(item => item.abbrev === question.abbrev)) {
                            let questionInBlockDto = _this.convertQuestionIntoQuestionInBlock(question);
                            if (block.questionsInBlock.length > 0) {
                                orderNumber = block.questionsInBlock[block.questionsInBlock.length - 1].orderNumber + 1;
                            } else {
                                orderNumber = 1;
                            }
                            questionInBlockDto.orderNumber = orderNumber;
                            block.questionsInBlock.push(questionInBlockDto);
                        }
                    });
                } else {
                    const shouldRemoveAll = _this.state.questionSearchText.length === 0;
                    if (shouldRemoveAll) {
                        block.questionsInBlock = block.questionsInBlock.filter(item => item.additional === false);
                    } else {
                        const questionsAbbrevs = questions.map(q => q.abbrev);
                        block.questionsInBlock = block.questionsInBlock.filter(q => !questionsAbbrevs.includes(q.abbrev));
                    }
                    copiedIsCheckedMap.set(blockId, false);
                }
            }
        });

        this.props.pickedData([...pickedBlocks]);

        if (this.state.blockQuestionsMap.has(blockId)) {
            const currentBlockQuestions = this.state.blockQuestionsMap.get(blockId);
            
            const updatedBlockQuestionsMap = new Map(this.state.blockQuestionsMap);
            updatedBlockQuestionsMap.set(blockId, currentBlockQuestions);
            
            const updatedActiveBlock = {
                ...this.state.activeBlock,
                questionsInBlock: pickedBlocks.find(block => block.id === blockId)?.questionsInBlock || []
            };
            
            this.setState({
                blockQuestionsMap: updatedBlockQuestionsMap,
                isCheckedMap: copiedIsCheckedMap,
                pickedBlocks: [...pickedBlocks],
                activeBlock: updatedActiveBlock
            });
        } else {
            const updatedActiveBlock = {
                ...this.state.activeBlock,
                questionsInBlock: pickedBlocks.find(block => block.id === blockId)?.questionsInBlock || []
            };
            
            this.setState({
                isCheckedMap: copiedIsCheckedMap,
                pickedBlocks: [...pickedBlocks],
                activeBlock: updatedActiveBlock
            });
        }
    };

    handleClose = (event) => {
        const newBlocks = this.props.pickedBlocks.pickedBlocks.map(block => {
            const hasQuestions = block.questionsInBlock.length !== 0;
            const hasAdditionalQuestions = block.additionalQuestions.length !== 0;

            if(!hasQuestions && !hasAdditionalQuestions) {
                block.questionsInBlock = this.state.blockQuestionsMap
                    .get(block.id)?.filter(x => x.additional === false)?.map(this.convertQuestionIntoQuestionInBlock) ?? [];

                block.additionalQuestions = this.state.blockQuestionsMap
                    .get(block.id)?.filter(x => x.additional === true)?.map(this.convertQuestionIntoQuestionInBlock) ?? [];
            }
            return block;
        });
        
        this.setState({
            showBlocks: false,
            showAddQuestion: false,
        });

       this.props.pickedData(newBlocks);
    };

    showQuestionsTab = (block) => {
        const blockWithQuestions = {...block};
        const fetchedData = this.state.blockQuestionsMap.get(block.id);
        
        if (fetchedData) {
            if (Array.isArray(fetchedData)) {
                blockWithQuestions.additionalQuestions = fetchedData.filter(q => q.additional === true);
            }
        }
        
        this.setState(
            {
                showAddQuestion: true,
                activeBlock: blockWithQuestions
            }
        );
    };

    handleCollapse = (key, blockId) => {
        let copiedIsCollapsedMap = this.state.isCollapsedMap;
        let isCollapsed = copiedIsCollapsedMap.get(key);
        
        if (isCollapsed) {
            copiedIsCollapsedMap.set(key, false);
        } else {
            copiedIsCollapsedMap.set(key, true);
            
            const hasQuestionsLoaded = this.state.blockQuestionsMap.has(blockId);
            
            if (hasQuestionsLoaded) {
                const data = this.state.blockQuestionsMap.get(blockId);
                const pickedBlocks = [...this.props.pickedBlocks.pickedBlocks];
                const blockToUpdate = pickedBlocks.find(block => block.id === blockId);
                
                if (blockToUpdate) {
                    if (!blockToUpdate.additionalQuestions) {
                        blockToUpdate.additionalQuestions = [];
                    }
                    
                    const questionsArray = Array.isArray(data) ? data : [];
                    
                    const additionalQuestions = questionsArray.filter(q => q.additional === true);
                    const standardQuestions = questionsArray.filter(q => q.additional === false);
                    
                    blockToUpdate.additionalQuestions = additionalQuestions;

                    if (!blockToUpdate.questionsInBlock) {
                        blockToUpdate.questionsInBlock = [];
                    }
                    
                    standardQuestions.forEach(standardQuestion => {
                        const isAlreadyInBlock = blockToUpdate.questionsInBlock.some(
                            q => q.abbrev === standardQuestion.abbrev
                        );
                        
                        if (!isAlreadyInBlock) {
                            const questionInBlockDto = this.convertQuestionIntoQuestionInBlock(standardQuestion);
                            if (blockToUpdate.questionsInBlock.length > 0) {
                                const lastOrderNumber = blockToUpdate.questionsInBlock[blockToUpdate.questionsInBlock.length - 1].orderNumber;
                                questionInBlockDto.orderNumber = lastOrderNumber + 1;
                            } else {
                                questionInBlockDto.orderNumber = 1;
                            }
                            blockToUpdate.questionsInBlock.push(questionInBlockDto);
                        }
                    });
                    
                    this.props.pickedData([...pickedBlocks]);
                    this.setState({
                        pickedBlocks: [...pickedBlocks]
                    });
                }
            }
            else if (!this.state.blockQuestionsLoading.get(blockId)) {
                const blockQuestionsLoading = new Map(this.state.blockQuestionsLoading);
                blockQuestionsLoading.set(blockId, true);
                this.setState({ blockQuestionsLoading });
                
                const url = PropertyBucket.getBlockQuestions(blockId);
                httpService.getService(url, 'GET')
                    .then(data => {
                        const blockQuestionsMap = new Map(this.state.blockQuestionsMap);
                        blockQuestionsMap.set(blockId, data);
                        
                        const pickedBlocks = [...this.props.pickedBlocks.pickedBlocks];
                        
                        const blockToUpdate = pickedBlocks.find(block => block.id === blockId);
                        
                        if (blockToUpdate) {
                            if (!blockToUpdate.additionalQuestions) {
                                blockToUpdate.additionalQuestions = [];
                            }
                            
                            const questionsArray = Array.isArray(data) ? data : [];
                            
                            const additionalQuestions = questionsArray.filter(q => q.additional === true);
                            const standardQuestions = questionsArray.filter(q => q.additional === false);
                            
                            blockToUpdate.additionalQuestions = additionalQuestions;
                            
                            if (!blockToUpdate.questionsInBlock) {
                                blockToUpdate.questionsInBlock = [];
                            }
                            
                            standardQuestions.forEach(standardQuestion => {
                                const isAlreadyInBlock = blockToUpdate.questionsInBlock.some(
                                    q => q.abbrev === standardQuestion.abbrev
                                );
                                
                                if (!isAlreadyInBlock) {
                                    const questionInBlockDto = this.convertQuestionIntoQuestionInBlock(standardQuestion);
                                    if (blockToUpdate.questionsInBlock.length > 0) {
                                        const lastOrderNumber = blockToUpdate.questionsInBlock[blockToUpdate.questionsInBlock.length - 1].orderNumber;
                                        questionInBlockDto.orderNumber = lastOrderNumber + 1;
                                    } else {
                                        questionInBlockDto.orderNumber = 1;
                                    }
                                    blockToUpdate.questionsInBlock.push(questionInBlockDto);
                                }
                            });
                            
                        }
                        
                        const updatedBlockQuestionsLoading = new Map(this.state.blockQuestionsLoading);
                        updatedBlockQuestionsLoading.set(blockId, false);
                        
                        this.setState({
                            blockQuestionsMap,
                            blockQuestionsLoading: updatedBlockQuestionsLoading,
                            pickedBlocks: [...pickedBlocks]
                        });
                        
                        this.props.pickedData([...pickedBlocks]);
                    })
                    .catch(error => {
                        console.error('Error fetching questions:', error);
                        
                        const updatedBlockQuestionsLoading = new Map(this.state.blockQuestionsLoading);
                        updatedBlockQuestionsLoading.set(blockId, false);
                        
                        this.setState({
                            showPopup: true,
                            popUp: {title: 'Błąd', notification: 'Nie udało się załadować pytań dla bloku', type: 'error'},
                            blockQuestionsLoading: updatedBlockQuestionsLoading
                        });
                    });
            }
        }
        
        this.setState({
            isCollapsedMap: copiedIsCollapsedMap
        });
    };
    
    handleSaveList(pickedBlocks) {
        /*
        /  The block of code saves added questions to
        /   to the general question pool.
        */
        let listName = this.state.listData.name;
        let areAllFieldsPassed = true;
        let isNameValidated = validator.getMustBeChecked(listName, 'listNameAlert', PropertyBucket.getListNameMustBeChosen());
        let isNameLongEnough = validator.getMustBeLongEnough(listName, 'listNameAlert', PropertyBucket.tooLongListTextMessage(), 500);
        let areAnyBlocksChosen = validator.getBlocksMustBeChosen(pickedBlocks, 'blocksChosenAlert', PropertyBucket.getBlockMustBeChosen());

        if (isNameValidated && isNameLongEnough) {
            let newClasses = this.state.listNameClasses;
            let index = newClasses.indexOf('alertBorder');
            areAllFieldsPassed ? areAllFieldsPassed = true : null;
            if (index !== -1) {
                newClasses.splice(newClasses.indexOf('alertBorder'), 1);
                this.setState({listNameClasses: newClasses});
            }
        } else {
            areAllFieldsPassed = false;
            let newClasses = this.state.listNameClasses;
            if (!newClasses.includes('alertBorder')) {
                newClasses.push('alertBorder');
                this.setState({listNameClasses: newClasses});
            }
        }

        if (areAnyBlocksChosen) {
            areAllFieldsPassed ? areAllFieldsPassed = true : null;
        } else {
            areAllFieldsPassed = false;
        }
        if (areAllFieldsPassed) {
            this.isWaitingOnOff(true);
            let blocksToSave = pickedBlocks.slice();
            blocksToSave.forEach(function (pickedBlock, index) {
                let blockInListDto = new BlockInListDto();
                blockInListDto.id = pickedBlock.id;
                blockInListDto.blockInListId = pickedBlock.blockInListId;
                blockInListDto.code = pickedBlock.code;
                blockInListDto.name = pickedBlock.name;
                blockInListDto.active = pickedBlock.active;
                blockInListDto.block = pickedBlock;//new line
                blockInListDto.questionsInBlock = pickedBlock.questionsInBlock;

                blocksToSave[index] = blockInListDto;
            });

            let program = '';
            if (getUserRole(this.props.userData) === 'SA') {
                program = 'UP';
            } else {
                if (store.getState().programs.selected) {
                    program = store.getState().programs.selected.code;
                } else {
                    program = getUserProgramFromPwd(this.props.userData);
                }
            }

            let listDto = new QuestionListDto();
            listDto.name = listName;
            listDto.program = program;
            listDto.active = false;
            listDto.blocksInList = blocksToSave;
            let url;
            let callPromise;
            if (typeof this.props.match.params.listId !== 'undefined') {
                url = PropertyBucket.editList(this.listId);
                listDto.id = this.props.match.params.listId;
                callPromise = httpService.getServiceWithSupportErrors(url, 'PUT', listDto);
            } else {
                url = PropertyBucket.saveList();
                callPromise = httpService.getServiceWithSupportErrors(url, 'POST', listDto);
            }

            let _this = this;
            callPromise.then(
                function (message) {
                    if (message.violations) {
                        _this.setState({
                            violations: (message.violations.length > 0 ? message.violations?.map(v => v.violation + '. ') : null),
                            disabled: 'disabled',
                            isWaiting: false
                        })
                    } else {
                        _this.setState({
                            listData: {
                                name: message.name,
                            },
                            violations: null,
                            disabled: 'disabled',
                            isChangeRoutePossible: true,
                            changeRouteAfterSave: true,
                            listDataSource: JSON.parse(JSON.stringify(_this.state.listData)),
                            pickedBlocksSource: JSON.parse(JSON.stringify(_this.state.pickedBlocks)),
                            showPopup: true,
                            popUp: {
                                title: 'Komunikat', notification: PropertyBucket.createListMessage(),
                                onCLick: () => {
                                    isURLContainString(_this.props.history.location.pathname, ['edit_list'])
                                        ? _this.props.history.goBack()
                                        : null;

                                    isURLContainString(_this.props.history.location.pathname, ['copy_list'])
                                        ? _this.props.history.push('/manage_lists/last')
                                        : null;

                                    isURLContainString(_this.props.history.location.pathname, ['create_list'])
                                        ? _this.props.history.push('/manage_lists/last')
                                        : null;
                                }
                            },
                            isWaiting: false
                        })
                    }
                    //clear pickedBlocks in redux state after success
                    _this.props.pickedData([]);
                },
                function (error) {
                    _this.setState({
                        showPopup: true,
                        popUp: {title: 'Błąd', notification: error, type: 'error'},
                        isWaiting: false
                    })
                }
            )
        }
    }

    listAddedQuestions = (questionsInBlock, block) => {
        let rows = [];
        let _this = this;
        if (questionsInBlock) {
            questionsInBlock.sort(function (a, b) {
                return a.orderNumber - b.orderNumber;
            });
            questionsInBlock.forEach(function (question, index) {

                const handleClickUp = () => {
                    _this.moveUp(questionsInBlock, index);

                    _this.setState({
                        showMoveQuestionAlert: true,
                        moveQuestionAlertContent: `Przesunięto pytanie o treści ${questionsInBlock[index - 1].questionContent} na pozycję ${index}. Obecnie focus na pytaniu nr ${index + 1} o treści ${questionsInBlock[index].questionContent}`,
                    });

                    setTimeout(() => {
                        _this.setState({
                            showMoveQuestionAlert: false,
                            moveQuestionAlertContent: '',
                        })
                    }, 3000)
                };

                const handleClickDown = () => {
                    _this.moveDown(questionsInBlock, index);

                    _this.setState({
                        showMoveQuestionAlert: true,
                        moveQuestionAlertContent: `Przesunięto pytanie o treści ${questionsInBlock[index + 1].questionContent} na pozycję ${index + 2}. Obecnie focus na pytaniu nr ${index + 1} o treści ${questionsInBlock[index].questionContent}`,
                    });

                    setTimeout(() => {
                        _this.setState({
                            showMoveQuestionAlert: false,
                            moveQuestionAlertContent: '',
                        })
                    }, 3000)
                };

                let type = question.additional ? ' (D)' : ' (S)';
                let upDisabled = index === 0 ? 'disablled' : null;
                let downDisabled = index === questionsInBlock.length - 1 ? 'disablled' : null;
                let val = <li key={'quest_' + index} className='question-list-item'>
                    <div className='questionRow'>
                        <p>{(index + 1) + '. ' + question.questionContent + type}</p>
                    </div>
                    <div className='order-icons'>
                        <button
                            disabled={upDisabled}
                            onClick={handleClickUp}
                            type='button'
                            className='btn m-0 v-btn v-btn--disabled v-btn--icon'
                        >
                            <div className='v-btn__content'><i aria-hidden='true'
                                                               className='v-icon material-icons'>arrow_upward</i>
                            </div>
                            <span
                                className='sr-only'>Przesuń w górę pytanie nr {index + 1} o treści: {question.questionContent}</span>
                        </button>
                        <button
                            disabled={downDisabled}
                            onClick={handleClickDown}
                            type='button'
                            className='btn m-0 v-btn v-btn--disabled v-btn--icon'
                        >
                            <div className='v-btn__content'><i aria-hidden='true'
                                                               className='v-icon material-icons'>arrow_downward</i>
                            </div>
                            <span
                                className='sr-only'>Przesuń w dół pytanie nr {index + 1} o treści: {question.questionContent}</span>
                        </button>
                    </div>
                </li>;
                rows.push(val);
            });
            return rows;
        } else {
            return <p className='my-2'>Brak pytań</p>;
        }
    };

    questionFilterFunction = (question) => {
        if(!question) {
            return false;
        }
        
        if(!question.active) {
            return false;
        }

        const lowerSearchText = this.state.questionSearchText?.toLowerCase();
        return question.abbrev?.toLowerCase().includes(lowerSearchText) || question.question?.toLowerCase().includes(lowerSearchText);
    }

    filterAdditionalQuestionsBySelectedProgram = (additionalQuestions) => {
        const code = this.props.programs?.selected?.code;
        if (code) {
            return additionalQuestions?.filter(q => q.abbrev?.startsWith(code))
        }
        return additionalQuestions;
    };

    listBlockQuestions = (additionalQuestions) => {
        additionalQuestions = this.filterAdditionalQuestionsBySelectedProgram(additionalQuestions);

        let _this = this;
        let rows = [];
        let questionsInBlock = this.state.activeBlock.questionsInBlock;
        const filteredQuestions = filter(
            orderBy(
                additionalQuestions,
                question => question.abbrev.split('.').map((subString, i) => i === 0 ? subString : '0'.repeat(10 - subString.length) + subString)
            ),
            this.questionFilterFunction
        );
        const filteredQuestionsAbbrevs = filteredQuestions.map(q => q.abbrev);
        const checkedQuestionsAbbrevs = this.state.activeBlock.questionsInBlock.filter(q => q.additional).map(q => q.abbrev);
        const isAllQuestionsChecked = filteredQuestionsAbbrevs.every(id => checkedQuestionsAbbrevs.includes(id));

        let checkAll = <div className='question_rows mb-2' key='checkAll'>
            <Checkbox id='checkAll' edge='end' color='primary' checked={isAllQuestionsChecked}
                      name={'checkAll'}
                      onChange={(e) => _this.addAllQuestions(_this.state.activeBlock.id, filteredQuestions, e)}/>
            <label htmlFor='checkAll' className='ml-3'>Zaznacz wszystkie</label>
        </div>;
        filteredQuestions.forEach(function (question, index) {
            const labelId = `checkbox-list-label-${index}`;
            const inputId = `checkbox-list-input-${index}`;
            let checked = questionsInBlock.some(item => item.abbrev === question.abbrev);
            let val = <div className='question_rows col-6' key={index}>
                <Checkbox edge='end' color='primary' checked={checked}
                          label={question.question}
                          id={inputId}
                          name={'checked' + question.abbrev}
                          onChange={(e) => _this.addQuestion(_this.state.activeBlock.id, question, e)}/>
                <label htmlFor={inputId} id={labelId} className='ml-3'>{question.abbrev} {question.question}</label>
            </div>;

            rows.push(val);
        });

        return (
            <>
                {checkAll}
                <div className="row">
                    {rows}
                </div>
            </>
        )
    };

    moveBlockUp(blocks, index) {
        let prev = index - 1;
        const temp = blocks[prev];
        blocks[prev] = blocks[index];
        blocks[index] = temp;
        
        const pickedBlocks = [...blocks];
        
        this.props.pickedData([...pickedBlocks]);
        
        this.setState({
            isWaiting: false,
            pickedBlocks: [...pickedBlocks]
        });
    }

    moveBlockDown(blocks, index) {
        let next = index + 1;
        const temp = blocks[next];
        blocks[next] = blocks[index];
        blocks[index] = temp;
        
        const pickedBlocks = [...blocks];
        
        this.props.pickedData([...pickedBlocks]);
        
        this.setState({
            isWaiting: false,
            pickedBlocks: [...pickedBlocks]
        });
    }

    moveUp(questions, index) {
        let prev = index - 1;
        let prevOrderNumber = questions[prev].orderNumber;
        questions[prev].orderNumber = questions[index].orderNumber;
        questions[index].orderNumber = prevOrderNumber;
        questions.sort(function (a, b) {
            return a.orderNumber - b.orderNumber;
        });
        
        const pickedBlocks = [...this.props.pickedBlocks.pickedBlocks];
        
        this.props.pickedData([...pickedBlocks]);
        
        this.setState({
            isWaiting: false,
            pickedBlocks: [...pickedBlocks]
        });
    }

    moveDown(questions, index) {
        let next = index + 1;
        let nextOrderNumber = questions[next].orderNumber;
        questions[next].orderNumber = questions[index].orderNumber;
        questions[index].orderNumber = nextOrderNumber;
        questions.sort(function (a, b) {
            return a.orderNumber - b.orderNumber;
        });
        
        const pickedBlocks = [...this.props.pickedBlocks.pickedBlocks];
        
        this.props.pickedData([...pickedBlocks]);
        
        this.setState({
            isWaiting: false,
            pickedBlocks: [...pickedBlocks]
        });
    }

    
    syncNewlyAddedBlocksWithCachedQuestions = (currentBlocks, prevBlocks) => {
        const newlyAddedBlocks = currentBlocks.filter(block => 
            !prevBlocks.some(prevBlock => prevBlock.id === block.id)
        );
        
        if (newlyAddedBlocks.length === 0) return;
        
        const blocksToUpdate = [];
        
        newlyAddedBlocks.forEach(block => {
            if (this.state.blockQuestionsMap.has(block.id)) {
                const cachedQuestions = this.state.blockQuestionsMap.get(block.id);
                
                if (!block.additionalQuestions) {
                    block.additionalQuestions = [];
                }
                
                if (!block.questionsInBlock) {
                    block.questionsInBlock = [];
                }
                
                if (Array.isArray(cachedQuestions)) {
                    const additionalQuestions = cachedQuestions.filter(q => q.additional === true);
                    const standardQuestions = cachedQuestions.filter(q => q.additional === false);
                    
                    block.additionalQuestions = additionalQuestions;
                    
                    standardQuestions.forEach(standardQuestion => {
                        const isAlreadyInBlock = block.questionsInBlock.some(
                            q => q.abbrev === standardQuestion.abbrev
                        );
                        
                        if (!isAlreadyInBlock) {
                            const questionInBlockDto = this.convertQuestionIntoQuestionInBlock(standardQuestion);
                            if (block.questionsInBlock.length > 0) {
                                const lastOrderNumber = block.questionsInBlock[block.questionsInBlock.length - 1].orderNumber;
                                questionInBlockDto.orderNumber = lastOrderNumber + 1;
                            } else {
                                questionInBlockDto.orderNumber = 1;
                            }
                            block.questionsInBlock.push(questionInBlockDto);
                        }
                    });
                    
                    blocksToUpdate.push(block);
                }
            }
        });
        
        if (blocksToUpdate.length > 0) {
            const pickedBlocks = [...currentBlocks];
            this.props.pickedData(pickedBlocks);
            this.setState({
                pickedBlocks: pickedBlocks
            });
        }
    }

    listBlocksPicked = (blocks) => {
        let _this = this;
        let blocksPicked = [];
        let userRole = localStorage.getItem('userRole');
        blocks.forEach(function (block, index) {
            if (block) {
                let key = 'pickedBlock' + block.id;
                let isChecked = _this.state.isCollapsedMap.get(key);
                typeof isChecked === 'undefined' ? isChecked = false : null;
                const isEmptyListOfAdditionalQuestions = _this.filterAdditionalQuestionsBySelectedProgram(block?.additionalQuestions)?.length === 0;
                
                const handleBlockClickUp = () => {
                    _this.moveBlockUp(blocks, index);
                };

                const handleBlockClickDown = () => {
                    _this.moveBlockDown(blocks, index);
                };
                
                let upDisabled = index === 0 ? 'disabled' : null;
                let downDisabled = index === blocks.length - 1 ? 'disabled' : null;
                
                let val = <li key={index}>
                    <div className={`pickedBlocks ${isChecked ? 'open' : 'closed'}`} key={index} id={key}>
                        <div id={'block' + block.id} className='blockTitle'>
                            <div className="d-flex align-items-center justify-content-between w-100" onClick={() => _this.handleCollapse(key, block.id)}>
                                <div className="d-flex align-items-center">
                                    <h4>{(index + 1) + '. ' + block.name}</h4>
                                </div>
                                <div className="d-flex">
                                    <div className='order-icons mr-3'>
                                        <button
                                            disabled={upDisabled}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleBlockClickUp();
                                            }}
                                            type='button'
                                            tabIndex={upDisabled ? -1 : 0}
                                            className={`btn m-0 v-btn ${upDisabled ? 'v-btn--disabled' : ''} v-btn--icon`}
                                            style={{
                                                backgroundColor: upDisabled ? '#e0e0e0' : '',
                                                opacity: upDisabled ? 0.5 : 1,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <div className='v-btn__content'><i aria-hidden='true'
                                                                          className='v-icon material-icons'>arrow_upward</i>
                                            </div>
                                            <span className='sr-only'>Przesuń w górę blok {block.name}</span>
                                        </button>
                                        <button
                                            disabled={downDisabled}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleBlockClickDown();
                                            }}
                                            type='button'
                                            tabIndex={downDisabled ? -1 : 0}
                                            className={`btn m-0 v-btn ${downDisabled ? 'v-btn--disabled' : ''} v-btn--icon`}
                                            style={{
                                                backgroundColor: downDisabled ? '#e0e0e0' : '',
                                                opacity: downDisabled ? 0.5 : 1,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <div className='v-btn__content'><i aria-hidden='true'
                                                                          className='v-icon material-icons'>arrow_downward</i>
                                            </div>
                                            <span className='sr-only'>Przesuń w dół blok {block.name}</span>
                                        </button>
                                    </div>
                                    <button className={isChecked ? 'btn block-icon' : 'btn block-icon-collapsed'} onClick={(e) => {
                                            e.stopPropagation();
                                            _this.handleCollapse(key, block.id)
                                        }}>
                                        <i data-v-7d286a08='' aria-hidden='true'
                                           className='v-icon material-icons theme--light white--text'>keyboard_arrow_down</i>
                                        <span className='sr-only'>{isChecked ? 'Ukryj listę pytań' : `Pokaż listę pytań z bloku: ${block.name}. Możesz edytować kolejność pytań na liście${(userRole !== 'SA') && ' lub dodać pytanie do listy.'}`}</span>
                                    </button>
                                </div>
                            </div>
                            <div className='clearfix'></div>
                        </div>
                        <Collapse isOpened={isChecked} checkTimeout={'0'}>
                            {isChecked && <div>
                                {_this.state.blockQuestionsLoading.get(block.id) ? (
                                    <div className="text-center my-3">
                                        <p>Ładowanie pytań...</p>
                                        <Waiter loading={true} />
                                    </div>
                                ) : (
                                <div>
                                    {userRole !== 'SA' && (
                                        <div className="add-question-btn">
                                            <button className='btn save-btn'
                                                   disabled={_this.state.disabled || isEmptyListOfAdditionalQuestions}
                                                   onClick={() => _this.showQuestionsTab(block)}><i data-v-db6946bc=''
                                                                                                    aria-hidden='true'
                                                                                                    className='v-icon material-icons theme--light v-list-text'>add</i><span>DODAJ PYTANIE</span>
                                            </button>
                                            {isEmptyListOfAdditionalQuestions &&
                                                <div className="info">Lista dodatkowych pytań jest pusta</div>}
                                        </div>
                                    )}
                                    <p id={'added_questions_' + block.id} className='h4 mt-3 mb-5'>Lista pytań</p>
                                </div>
                                )}
                                {!_this.state.blockQuestionsLoading.get(block.id) && (
                                <ul className='questions-list' style={isEmptyListOfAdditionalQuestions ? {paddingTop: '16px'} : null}>{_this.listAddedQuestions(block.questionsInBlock, block)}</ul>
                                )}
                            </div>}
                        </Collapse>
                    </div>


                </li>;
                blocksPicked.push(val);
            }
        });
        return blocksPicked;
    };

    render() {
        let blocksData = store.getState().createListBlocks.blocks;
        let popUp;
        this.state.showPopup ?
            popUp = <PopUp type={this.state.popUp.type}
                           title={this.state.popUp.title}
                           notification={this.state.popUp.notification}
                           link={this.state.popUp.link ? this.state.popUp.link : null} // cannot be undefined because of PopUp.js implementation
                           onClickEvent={this.state.popUp.onCLick}
                           closePopUp={this.handleClosePopUp}
            /> : null;
        return (<div id='list_create'>
            {popUp}
            {this.state.isPreventPromptEnabled &&
                <Prompt when={!this.state.isChangeRoutePossible || !this.state.isAnyBlocksSelected} message={this.preventChangeRoute}/>}

            {this.state.showBlocks && blocksData.length > 0
                ? (
                    <PopUp
                        customContent
                        handleClosePopup={this.handleClose}
                        title='Wybierz blok'
                        className='list-PopUp'
                    >
                        <div id='check_block_drag' className='popUp__content-scrolled'>
                            <CheckBoxListProvider blocksToRender={blocksData} refresh={this.handleClose}/>
                        </div>
                    </PopUp>
                ) : null
            }
            <h2 className='mb-4'>{this.state.title}</h2>
            <div className='row'>
                <div className='col-md-12'>
                    <Input
                        chartsCount={this.state.listData.name.length}
                        label='Nazwa listy'
                        inputId='list-name'
                        maxLength={500}
                        errorId='listNameAlert'
                        onChange={this.handleChangeName}
                        value={this.state.listData.name}
                        error={this.state.violations}
                        invalid={this.state.violations}
                    />
                </div>
            </div>
            <div id='blocks_section'>
                <button id='create_block_btn' className='btn save-btn' onClick={this.addBlock}
                        disabled={this.state.disabled || blocksData.length === 0}>WYBIERZ BLOK<span className='sr-only'> Musisz wybrać co najmniej jeden blok.</span>
                </button>
                {blocksData.length === 0 && <p className="info">Lista bloków jest pusta</p>}
            </div>
            <div id='blocks_chosen'>
                <h3 id='blocks_chosen_title'>Wybrane bloki</h3>
                <p id='blocksChosenAlert' className='red' role='alert'></p>
                {this.state.showAddQuestion ? (
                    <PopUp
                        customContent
                        handleClosePopup={this.handleClose}
                        title={`Pytania w bloku ${this.state.activeBlock.name || ''}`}
                        className='list-PopUp'
                    >
                        <Input placeholder="Szukaj" type="text" aria-label="Szukaj. Po wpisaniu każdego znaku, zawartość listy dynamicznie się zmieni." value={this.state.questionSearchText} onChange={(event) => {
                            this.setState({...this.state, questionSearchText: event.target.value});
                        }}/>
                        <div
                            className='popUp__content-scrolled'>{this.listBlockQuestions(this.state.activeBlock.additionalQuestions)}</div>
                    </PopUp>
                ) : null}
                <ul className='choosen-blocks-list'>
                    {this.listBlocksPicked(this.props.pickedBlocks.pickedBlocks)}
                </ul>
            </div>
            {this.state.showMoveQuestionAlert &&
                <span className="sr-only" role="alert">{this.state.moveQuestionAlertContent}</span>}
            <div className='btn_group'>
                <button className='btn save-btn' id='save_button'
                        disabled={this.state.disabled}
                        onClick={() => this.handleSaveList(this.props.pickedBlocks.pickedBlocks)}>ZAPISZ<span
                    className='sr-only'> listę</span>
                </button>
                <button
                    className='btn cancel-btn'
                    onClick={() => {
                        this.props.history.push('/manage_lists')
                    }
                    }
                    disabled={this.state.disabled}
                >
                    ANULUJ
                </button>
                <hr/>
            </div>
            <div id='waiter'><Waiter loading={this.state.isWaiting}/></div>
        </div>)
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        blocksData: () => dispatch(actionsBlocks.fetchActiveBlocks()),
        pickedData: data => dispatch(actionsBlocks.getPickedBlocks(data))
    }
};

export const CreateListProvider = connect(mapStateToProps, mapDispatchToProps)(CreateList);

